var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.87135 7.4502C9.87135 8.48373 9.03354 9.32155 8.00001 9.32155C6.96648 9.32155 6.12866 8.51843 6.12866 7.4502C6.12866 6.38198 6.96687 5.57886 8.00001 5.57886C9.03315 5.57886 9.87135 6.45215 9.87135 7.4502Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.514648 7.48538C0.514648 3.35166 3.86631 0 8.00003 0C12.1326 0 15.4854 3.35166 15.4854 7.48538C15.4854 9.96268 14.776 10.9738 11.3884 15.8016C10.6497 16.8544 9.78353 18.0888 8.76962 19.5595C8.39808 20.0963 7.60358 20.0963 7.232 19.5595C6.22167 18.0949 5.35807 16.8647 4.621 15.8147C1.22456 10.9764 0.514648 9.96517 0.514648 7.48538ZM4.88112 7.45029C4.88112 9.17037 6.27956 10.5692 8.00003 10.5692C9.71933 10.5692 11.1189 9.17037 11.1189 7.45029C11.1189 5.73021 9.71933 4.33138 8.00003 4.33138C6.28073 4.33138 4.88112 5.73021 4.88112 7.45029Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.1557a7b5ca124969384b55d173d3ea83.svg";
export { ForwardRef as ReactComponent };